export default "__VITE_ASSET__CkqZQpFK__"